import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CategorySeason from "@/pages/category/season/page";
import Schedule from "@/pages/schedule/page";
import LiveWatch from "@/pages/live/page";
import MatchDetail from "@/pages/detail/page";
import TeamDetail from "@/pages/team/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/season",
        element: <CategorySeason />,
      },
      {
        path: "schedule/:season",
        element: <Schedule />,
      },
      {
        path: "live/:matchId",
        element: <LiveWatch />,
      },
      {
        path: "detail/:matchId",
        element: <MatchDetail />,
      },
      {
        path: "team/:teamId",
        element: <TeamDetail />,
      },
      {
        path: "news",
        element: <NewsList />,
      },
      {
        path: "news/:newsId",
        element: <NewsDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;